// Question configuration for the WearSpray IQ registration questionnaire.
// Each entry drives one step of the wizard in IQQuestionnaire.jsx.

export const PRODUCT_OPTIONS = [
  "Sunscreen",
  "Moisturizer",
  "Skincare serum",
  "Hand sanitizer",
  "Insect repellent",
  "Fragrance",
  "Aloe or after sun care",
  "Other",
];

export const USAGE_OPTIONS = [
  "During exercise or outdoor activities",
  "At work",
  "While commuting",
  "While traveling",
  "At the beach or pool",
  "Caring for children or family",
  "In healthcare or caregiving environments",
  "During my everyday skincare routine",
  "Other",
];

export const FRUSTRATION_OPTIONS = [
  "I forget to reapply",
  "My products are not conveniently accessible",
  "I am too busy",
  "I am unsure when I need to reapply",
  "I do not know which products are appropriate for my needs",
  "I do not like carrying bottles or tubes",
  "I have no significant difficulty",
  "Other",
];

export const FEATURE_OPTIONS = [
  "Personalized skincare reminders",
  "UV exposure information",
  "Wearable biometric insights",
  "Skincare routine recommendations",
  "Environmental and activity based reminders",
  "Learning more about my skincare habits",
  "Connecting smartwatch insights with immediate product application",
];

export const VALUE_OPTIONS = ["Extremely valuable", "Somewhat valuable", "Not sure yet", "Not particularly valuable"];

export const DEVICE_OPTIONS = [
  "Apple Watch",
  "Samsung Galaxy Watch",
  "Garmin",
  "Fitbit or Pixel Watch",
  "WHOOP",
  "Oura Ring",
  "Other wearable",
  "None",
];

export const EVAL_INTEREST_OPTIONS = [
  "Yes, I would like to participate if eligible",
  "Maybe, please send me more information",
  "I only want updates for now",
];

export const AGE_RANGE_OPTIONS = ["Under 18", "18-24", "25-34", "35-44", "45-54", "55-64", "65+", "Prefer not to say"];

// field: key on the answers object. otherField: key for the free-text "Other" value.
export const QUESTIONS = [
  {
    key: "products",
    field: "products",
    otherField: "products_other",
    type: "multi",
    title: "What products would you most like to have instantly accessible?",
    options: PRODUCT_OPTIONS,
  },
  {
    key: "usage",
    field: "usage_contexts",
    otherField: "usage_other",
    type: "multi",
    title: "When would you find WearSpray most useful?",
    options: USAGE_OPTIONS,
  },
  {
    key: "frustrations",
    field: "frustrations",
    otherField: "frustrations_other",
    type: "multi",
    title: "What makes it difficult to maintain your skincare routine?",
    options: FRUSTRATION_OPTIONS,
  },
  {
    key: "features",
    field: "features",
    type: "multi",
    title: "Which WearSpray IQ features interest you most?",
    options: FEATURE_OPTIONS,
  },
  {
    key: "value",
    field: "value_perception",
    type: "single",
    title: "Would you find value in technology that reminds you when to reapply a product and provides immediate access to it?",
    options: VALUE_OPTIONS,
  },
  {
    key: "devices",
    field: "devices",
    otherField: "devices_other",
    type: "multi",
    title: "Which devices do you currently use?",
    options: DEVICE_OPTIONS,
  },
  {
    key: "feedback",
    field: "open_feedback",
    type: "text",
    title: "If WearSpray IQ could solve one problem in your personal care routine, what would it be?",
    optional: true,
  },
  {
    key: "eval",
    field: "eval_interest",
    type: "single",
    title: "Would you be interested in future WearSpray IQ product evaluations?",
    options: EVAL_INTEREST_OPTIONS,
  },
];
